import { postJson } from "./http";

/** POST-запрос к Space API */
export function spacePost<TResponse>(path: string, body: unknown): Promise<TResponse> {
    return postJson<TResponse>(`${import.meta.env.VITE_SPACE_API_URL}${path}`, body);
}
